<template>
  <div class="assessment">
    <div class="view-title">我的应用</div>
    <div class="app-box"
         v-loading="loading">
      <div class="app-item"
           v-for="(app, idx) in apps"
           :key="idx">
        <div class="top-app">
          <div>
            <img :src="`/apiService/virus/common/download/appIcon?icon=${app.id}`"
                 alt="icon">
            <div class="app-title">
              <h3>{{app.appName}}</h3>
              <p>包名：{{app.pkg}}</p>
            </div>
          </div>
          <gt-button type="success"
                     class="primary-btn fr"
                     @click="$router.push({name: 'assessmentReport', params: {id: app.appid}})">查看更多</gt-button>
        </div>
        <div class="bottom-app">
          <p>当前应用安全评估状态（共<span>{{app.num}}</span>个版本）</p>
          <ul>
            <li v-for="(label, field) in statusMap"
                :key="field">
              <img :src="imgPath(field)">
              <router-link class="back-link"
                           :to="{name: 'assessmentReport', params: {id: app.appid}, query: {status: field}}">
                <span>{{label}}</span>
                <span>({{app[field]}})</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="no-data"
           v-if="!apps.length">
        <h3>暂无数据</h3>
      </div>
    </div>
    <gt-pagination class="pagination"
                   v-if="apps.length"
                   background
                   layout="total, prev, pager, next, jumper"
                   :total="total"
                   :current-page="page"
                   :page-size="size"
                   @current-change="handlePageChange($event)"></gt-pagination>
  </div>
</template>

<script>
import { queryApplicationList } from '@/api/personal/index'
export default {
  name: 'assessment',
  components: {

  },
  data () {
    return {
      loading: false,
      apps: [],
      statusMap: {
        unfilled: '未填写',
        unsubmit: '待提交',
        audit: '审核中',
        failure: '审核不通过',
        success: '评估完成'
      },
      size: 4,
      page: 1,
      total: 0
    }
  },
  methods: {
    imgPath (field) {
      return require(`@/assets/images/status/${field}.png`)
    },
    handlePageChange (page) {
      this.getData(page)
    },
    async getData (page) {
      this.loading = true
      if (page) this.page = page
      const params = {
        pageSize: this.size,
        currentPage: this.page
      }
      if (this.$route.query.status !== undefined) params.status = Number(this.$route.query.status)
      const data = await queryApplicationList(params)
      this.loading = false
      this.apps = data.data.data.list
      this.total = data.data.data.total
      this.apps.forEach(item => {
        let num = Object.keys(this.statusMap).reduce((total, cur) => {
          return total + item[cur]
        }, 0)
        this.$set(item, 'num', num)
      })
    }
  },
  created () {
    this.getData()
  },
  beforeRouteEnter (to, from, next) {
    next({ name: from.name || 'overview' })
  }
}
</script>

<style lang='less' scoped>
.assessment {
  .view-title {
    padding-bottom: 6px;
    border-bottom: 2px solid #1f9b42;
    margin: 30px 0 12px;
  }
  .app-box {
    margin-top: 16px;
    .app-item {
      padding: 17px 30px 20px 20px;
      border: 1px solid #dddddd;
      margin-bottom: 10px;
      margin-left: 10px;
      box-shadow: 0 0 4px 0 rgba(68, 79, 106, 0.12);
      height: 180px;
      background: #fafcff;
      .top-app {
        > div {
          display: inline-block;
        }
        img {
          width: 60px;
          height: 60px;
          display: inline-block;
          // border: 1px solid #ddd;
          // border-radius: 4px;
          vertical-align: middle;
        }
        .app-title {
          display: inline-block;
          vertical-align: middle;
          margin-left: 24px;
          h3 {
            font-size: 16px;
            color: #333;
            font-weight: bold;
          }
          p {
            margin-top: 12px;
            font-size: 14px;
            color: #666666;
          }
        }
      }
      .bottom-app {
        padding: 14px 45px 20px 82px;
        font-size: 14px;
        p {
          margin-bottom: 20px;
        }
        ul {
          display: flex;
          li {
            flex: 1;
            img {
              width: 26px;
              height: 26px;
              margin-right: 10px;
              margin-top: -6px;
            }
            .back-link {
              &:hover {
                text-decoration: underline;
                color: #337ab7;
              }
            }
          }
        }
      }
    }
  }
  .no-data {
    margin-left: 12px;
    height: 150px;
    border: 1px solid #dddddd;
    box-shadow: 0 0 4px 0 rgba(68, 79, 106, 0.12);
    text-align: center;
    h3 {
      color: #999999;
      line-height: 150px;
    }
  }
  .pagination {
    float: right;
    margin-top: 20px;
  }
}
</style>
<style lang="less">
.assessment {
  .gt-button {
    width: 80px;
  }
}
</style>
